import { Pipe, PipeTransform, LOCALE_ID, Injector } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({ name: 'distance' })
export class DistancePipe implements PipeTransform {

    constructor(private injector: Injector) { }

    public transform(value: number): string {
        const localeId = this.injector.get(LOCALE_ID);
        const formater = new DecimalPipe(localeId);
        let result;
        if (value < 1) {
            result = (Math.ceil(value * 100) * 10) + ' m';
        } else {
            result = formater.transform(value, '1.0-1') + ' km';
        }
        return result;
    }
}
